import { render, staticRenderFns } from "./DiscussTopicList.vue?vue&type=template&id=71c9dd18&scoped=true&"
import script from "./DiscussTopicList.vue?vue&type=script&lang=ts&"
export * from "./DiscussTopicList.vue?vue&type=script&lang=ts&"
import style0 from "./DiscussTopicList.vue?vue&type=style&index=0&id=71c9dd18&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c9dd18",
  null
  
)

export default component.exports